<template>
  <!-- 批量设置坑位 -->
  <el-dialog
    title="设置二级坑位"
    v-if="dialogVisible"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="50%"
    class="dialog"
    center
  >
    <div class="batch-set-pit" v-loading="listLoading">
      <div class="config-row">
        <div class="config-item">
          <span class="config-label">总坑位数量</span>
          <el-input
            v-model="configForm.total_slot"
            placeholder="请输入"
            @input="onHandleNeedCompute"
            @blur="onHandleConfigBlur('total_slot')"
          />
          <span class="config-unit">个</span>
        </div>
        <div class="config-item">
          <span class="config-label">采购保底坑位数量</span>
          <el-input
            v-model="configForm.guarantee_slot"
            placeholder="请输入"
            @input="onHandleNeedCompute"
            @blur="onHandleConfigBlur('guarantee_slot')"
          />
          <span class="config-unit">个</span>
        </div>
        <div class="config-item ratio-item">
          <span class="config-label">招商/买手坑位比例</span>
          <el-input
            v-model="configForm.merchant_ratio"
            placeholder="请输入"
            @input="onHandleNeedCompute"
            @blur="onHandleConfigBlur('merchant_ratio')"
          />
          <span class="ratio-separator">:</span>
          <el-input
            v-model="configForm.buyer_ratio"
            placeholder="请输入"
            @input="onHandleNeedCompute"
            @blur="onHandleConfigBlur('buyer_ratio')"
          />
        </div>
        <el-button
          type="primary"
          :loading="computeLoading"
          @click="onHandleCompute"
        >
          确定
        </el-button>
      </div>

      <div class="list-wrap">
        <template v-if="listData.length">
          <div v-if="buyerList.length" class="group-block">
            <div class="group-title">买手采购：</div>
            <div v-for="item in buyerList" :key="item.id" class="buyer-row">
              <div class="buyer-name">{{ item.fullname }}</div>
              <div class="buyer-slot-label">坑位</div>
              <span class="slot-value">{{ item.slot }}</span>
              <el-switch
                v-model="item.is_whitelist"
                class="whitelist-switch"
                :active-value="1"
                :inactive-value="0"
                @change="onHandleNeedCompute"
              />
              <span class="switch-label">白名单</span>
            </div>
          </div>

          <div v-if="merchantList.length" class="group-block">
            <div class="group-title">招商采购：</div>
            <div v-for="item in merchantList" :key="item.id" class="buyer-row">
              <div class="buyer-name">{{ item.fullname }}</div>
              <div class="buyer-slot-label">坑位</div>
              <span class="slot-value">{{ item.slot }}</span>
              <el-switch
                v-model="item.is_whitelist"
                class="whitelist-switch"
                :active-value="1"
                :inactive-value="0"
                @change="onHandleNeedCompute"
              />
              <span class="switch-label">白名单</span>
            </div>
          </div>
        </template>

        <div v-if="!listLoading && listData.length === 0" class="empty-text">
          暂无数据
        </div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="onHandleClose">取 消</el-button>
      <el-button
        type="primary"
        :loading="submitLoading"
        :disabled="needCompute"
        @click="onHandleSubmit"
        >确认</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import tool from "@/utils/tools/tool";
import {
  postBuyerCategoryCompute,
  postBuyerCategoryList,
  postBuyerCategorySave,
} from "@/api/generalControl/category";
export default {
  name: "batchSetPit",
  components: {},
  data() {
    return {
      dialogVisible: false,
      submitLoading: false, // 确认按钮
      computeLoading: false, // 确定按钮
      listLoading: false,
      needCompute: false, // 改动配置或白名单后，需重新点确定
      listData: [],
      cid: "",
      logistic_business_id: "",
      // 坑位配置
      configForm: {
        total_slot: 0, // 总坑位数量
        guarantee_slot: 0, // 采购保底坑位数量
        merchant_ratio: 0, // 招商组比例
        buyer_ratio: 0, // 买手组比例
      },
    };
  },
  computed: {
    // 买手采购
    buyerList() {
      return this.listData.filter((item) => Number(item.buyer_type) === 3);
    },
    // 招商采购
    merchantList() {
      return this.listData.filter((item) => Number(item.buyer_type) === 2);
    },
  },
  methods: {
    async onInitData(cid, logistic_business_id) {
      Object.assign(this.$data.configForm, this.$options.data().configForm);
      this.cid = cid;
      this.logistic_business_id = logistic_business_id;
      this.dialogVisible = true;
      this.submitLoading = false;
      this.computeLoading = false;
      this.needCompute = false;
      this.listData = [];
      await this.getBuyerSlotList();
    },
    // 配置、白名单改动
    onHandleNeedCompute() {
      this.needCompute = true;
    },
    onHandleConfigBlur(field) {
      const value = this.configForm[field];
      this.configForm[field] = value == 0 ? 0 : tool.filterUnNumber(value);
    },
    // 采购坑位列表
    async getBuyerSlotList() {
      this.listLoading = true;
      try {
        const res = await postBuyerCategoryList({
          cid: this.cid,
          logistic_business_id: this.logistic_business_id,
        });
        this.listData = res.data.list || [];
        Object.assign(this.configForm, res.data.config);
        this.needCompute = false;
      } catch (error) {
        console.log(error, "postBuyerCategoryList");
      } finally {
        this.listLoading = false;
      }
    },
    // 确定-重新计算坑位
    async onHandleCompute() {
      this.computeLoading = true;
      try {
        const res = await postBuyerCategoryCompute({
          logistic_business_id: this.logistic_business_id,
          cid: this.cid,
          total_slot: this.configForm.total_slot,
          guarantee_slot: this.configForm.guarantee_slot,
          merchant_ratio: this.configForm.merchant_ratio,
          buyer_ratio: this.configForm.buyer_ratio,
          slot_list: this.listData.map((mItem) => ({
            buyer_id: mItem.id,
            is_whitelist: mItem.is_whitelist,
          })),
        });
        this.listData = res.data.list || [];
        this.needCompute = false;
      } catch (error) {
        console.log(error, "postBuyerCategoryCompute");
      } finally {
        this.computeLoading = false;
      }
    },
    onHandleClose() {
      this.dialogVisible = false;
    },
    async onHandleSubmit() {
      this.submitLoading = true;
      try {
        const res = await postBuyerCategorySave({
          logistic_business_id: this.logistic_business_id,
          cid: this.cid,
          total_slot: this.configForm.total_slot,
          guarantee_slot: this.configForm.guarantee_slot,
          merchant_ratio: this.configForm.merchant_ratio,
          buyer_ratio: this.configForm.buyer_ratio,
          slot_list: this.listData.map((mItem) => ({
            buyer_id: mItem.id,
            slot: mItem.slot,
            is_whitelist: mItem.is_whitelist,
          })),
        });
        this.$message({
          type: "success",
          message: res.msg || "保存成功",
        });
        this.dialogVisible = false;
        this.$emit("submit");
      } catch (error) {
        console.log(error, "postBuyerCategorySave");
      } finally {
        this.submitLoading = false;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.batch-set-pit {
  padding: 20px;
  .config-row {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 20px;
    flex-wrap: wrap;
  }

  .config-item {
    display: flex;
    align-items: center;
  }

  .config-label {
    margin-right: 8px;
    white-space: nowrap;
  }

  .config-item /deep/ .el-input {
    width: 120px;
  }

  .config-unit {
    margin-left: 8px;
    white-space: nowrap;
  }

  .ratio-item /deep/ .el-input {
    width: 80px;
  }

  .ratio-separator {
    margin: 0 8px;
  }

  .list-wrap {
    max-height: 400px;
    overflow: auto;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    padding: 20px;
  }

  .group-block + .group-block {
    margin-top: 20px;
  }

  .group-title {
    margin-bottom: 16px;
    font-weight: 600;
  }

  .buyer-row {
    display: flex;
    align-items: center;
    margin-bottom: 12px;
  }

  .buyer-name {
    width: 120px;
    text-align: right;
    margin-right: 16px;
  }

  .buyer-slot-label {
    margin-right: 10px;
  }

  .slot-value {
    width: 180px;
    margin-right: 24px;
  }

  .whitelist-switch {
    margin-right: 10px;
  }

  .switch-label {
    color: #606266;
  }

  .empty-text {
    color: #999;
    text-align: center;
    padding: 40px 0;
  }
}
</style>
